var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Box } from '@mui/material';
import styled from '@mui/material/styles/styled';
import { AddIcon } from '../../icons';
var Wrapper = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5f5f5',
    border: '1px dashed rgba(0,0,0,0.08)',
    borderRadius: '4px',
    cursor: 'pointer',
    width: 120,
    height: 120,
    '&:hover': {
        backgroundColor: '#EAEAEA'
    }
});
var Cube = function (props) {
    var file = props.file, onRemove = props.onRemove, restProps = __rest(props, ["file", "onRemove"]);
    return (React.createElement(Wrapper, __assign({}, restProps),
        React.createElement(AddIcon, null)));
};
export default Cube;
